import React, { SVGProps } from 'react';

const BetaBadgeSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={15} fill='none' {...props}>
    <g clipPath='url(#a)'>
      <path fill='#333' d='M33 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z' />
      <path
        fill='#fff'
        d='M9.613 7.38c.66.02 1.64.35 1.64 1.65 0 1.2-.84 1.97-2.81 1.97h-2.57V3.88h2.44c1.94 0 2.71.6 2.71 1.82 0 1.23-.91 1.61-1.41 1.66v.02Zm-1.33-2.5h-1.19v2.01h1.19c1.03 0 1.49-.29 1.49-1.04 0-.68-.37-.97-1.49-.97Zm.14 5.12c1.19 0 1.56-.38 1.56-1.09 0-.71-.37-1.06-1.56-1.06h-1.33V10h1.33Zm5.281-.02h3.59V11h-4.81V3.88h4.72v1.03h-3.5v1.93h3.29v.99h-3.29v2.15Zm9.941-6.1v1.03h-2.14V11h-1.22V4.91h-2.13V3.88h5.49ZM28.5 11l-.57-1.7h-2.88l-.57 1.7h-1.23l2.54-7.12h1.46L29.82 11H28.5Zm-3.12-2.69h2.21L26.5 5.07h-.03l-1.09 3.24Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h35v15H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default BetaBadgeSvg;
